/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ partners: NonNullable<unknown>, blocked: NonNullable<unknown>, amount: NonNullable<unknown> }} Partner_Billing_Board_Meta_OpenInputs */



/**
* | output |
* | --- |
* | "{partners} partners · {blocked} need attention, listed first · {amount}" |
*
* @param {Partner_Billing_Board_Meta_OpenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_meta_open = /** @type {((inputs: Partner_Billing_Board_Meta_OpenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Meta_OpenInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.partners} Partner · ${i?.blocked} erfordern Aufmerksamkeit, oben aufgeführt · ${i?.amount}`)
	return /** @type {LocalizedString} */ (`${i?.partners} partners · ${i?.blocked} need attention, listed first · ${i?.amount}`)
});